export enum PropertyListType {
    Application = "application",
    Favorite = "favorite",
    HomeMatch = "homeMatch",
    Recommendation = "recommendation",
    RejectedPreleads = "rejectedPreleads"
}

export type IPropertyListType = PropertyListType;
export enum PropertyListType {
    Application = "application",
    Favorite = "favorite",
    HomeMatch = "homeMatch",
    Recommendation = "recommendation",
    RejectedPreleads = "rejectedPreleads"
}

export type IPropertyListType = PropertyListType;
